export default "__VITE_ASSET__UkDTzB2y__"